import React from 'react';
import '../style/generalTab.css'
import { Alert, Loader, FormGroup, HorizontalRule } from 'arag-ui-lib';
import { DOTS, ERROR, MEDIUM, PALE } from "../helpers/constants";
import { FORM_GROUP_VARIANTS, SECONDARY_VARIANT_STYLE } from "../helpers/formGroupVariants";

const DocumentsTab = (props) => {

    const {
        failedToGetApplicationAttachments,
        fetchingAllApplicationAttachments,
        failedToGetDocumentMsg,
        deletingDocument,
        failedDeleteMsg,
        fetchingDocument,
        rowData
    } = props;

    if(fetchingAllApplicationAttachments){
        return (
            <div className='col-sm-12'>
                <Loader variant={DOTS} dotSize={MEDIUM}/>
            </div>
        )
    }
    return (
        <div className="col-sm-12 generalTab-wrapper">
            <form className="form-horizontal" >
                {
                    rowData?.map((data, index) => {
                        return <div key={index}>
                            <FormGroup
                                labelSize={'col-sm-4'}
                                inputSize={'col-sm-8'}
                                label={rowData[index].key}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: `${index}-document`,
                                    label: rowData[index].value,
                                }}
                                requiredStyle={SECONDARY_VARIANT_STYLE}
                                hasInlineElements={true}
                                inlineGroupElements={
                                    <div className='row col-sm-6'>{rowData[index].buttons}</div>
                                }
                                formGroupTestId={`document-${index}`}
                                formGroupInputTestId={`document-${index}-filename`}
                            />
                            <div className="row" >
                                <div className="col-sm-12">
                                    <HorizontalRule variant={PALE}/>
                                </div>
                            </div>
                        </div>
                    })
                }
            </form>
            { (failedToGetDocumentMsg || failedToGetApplicationAttachments) && (<Alert label={failedToGetApplicationAttachments || failedToGetDocumentMsg} variant={ERROR} />) }
            { failedDeleteMsg && (<Alert label={failedDeleteMsg} variant={ERROR} /> ) }
            { (fetchingDocument || deletingDocument) && ( <Loader variant={DOTS} dotSize={MEDIUM}/>) }
        </div>
    )
};

export default DocumentsTab;